import React from "react";
import { Link } from "react-router-dom";
import { Download, FileText } from "lucide-react";
import { trackEvent, EVENTS } from "@/utils/tracking";
import { useSiteSettings } from "@/hooks/useSiteSettings";

// Ivory/blush brochure CTA band — used to break up dark-on-dark sections
export default function BrochureCTA({
  heading = "Explore Our Event Deck",
  text = "See how Petals & Promises plans weddings, celebrations, corporate experiences, and devotional gatherings with thoughtful design and seamless execution.",
}) {
  const { brochureUrl } = useSiteSettings();
  const enabled = !!brochureUrl;

  return (
    <section id="brochure" data-testid="brochure-cta" className="relative py-20 md:py-28 bg-[#F4DCD8]/35 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 10% 30%, rgba(197,160,89,0.12), transparent 40%), radial-gradient(circle at 85% 70%, rgba(138,154,123,0.10), transparent 45%)"
      }} />
      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <p className="pill-rose">Download &amp; Share</p>
          <h2 className="font-display text-4xl md:text-5xl mt-5 text-[#3B312D] leading-[1.05]">
            {heading.split(" ").slice(0, -1).join(" ")}{" "}
            <span className="italic text-[#B65980]">{heading.split(" ").slice(-1)}</span>
          </h2>
          <p className="mt-5 text-[16px] text-[#3B312D]/80 max-w-xl leading-relaxed">{text}</p>
        </div>
        <div className="lg:col-span-5 flex flex-wrap gap-3 lg:justify-end">
          <a
            href={enabled ? brochureUrl : "#"}
            target={enabled ? "_blank" : undefined}
            rel={enabled ? "noreferrer noopener" : undefined}
            aria-disabled={!enabled}
            data-testid="brochure-download-btn"
            onClick={(e) => {
              if (!enabled) { e.preventDefault(); return; }
              trackEvent(EVENTS.BROCHURE_DOWNLOAD_CLICK, { location: "brochure-cta" });
            }}
            className={`btn-primary ${!enabled ? "opacity-60 cursor-not-allowed" : ""}`}
          >
            <Download size={15} /> Download Brochure
          </a>
          <Link to="/contact" data-testid="brochure-proposal-btn" onClick={() => trackEvent(EVENTS.PLAN_EVENT_CTA_CLICK, { location: "brochure-cta-proposal" })} className="btn-ghost">
            <FileText size={15} /> Request Custom Proposal
          </Link>
        </div>
      </div>
    </section>
  );
}
